//#################### Header ####################//

/* Note to self:
 *
 * Instead of applying the tailwind classes directly to the elements, I could
 * add/remove a custom class to the elements and define the styles in the
 * main.css file. This would make it easier to change the styles in the future
 * and would reduce code duplication.
 */

document.addEventListener('DOMContentLoaded', function() {

    // Function to check if the navbar should change color scheme
    function updateNavbarStyle() {

        const infoSection = document.getElementById('info');
        const navbar = document.getElementById('navbar');
        const mobileMenuButton = document.getElementById('mobile-menu-button');
        const mobileMenuBtnContainer = document.getElementById(
            'mobile-menu-btn-container');
        const logo = document.getElementById('nav-logo');
        const logoImage = logo.querySelector('img');

        // Get the current scroll position
        const scrollPosition = window.scrollY;
        // Get the top position of the info section to compare with the scroll position
        const infoSectionTop = infoSection.offsetTop;

        // Check if the color scheme needs to be updated
        const isLightScheme = scrollPosition <= infoSectionTop; // Add [- value] to offset the scroll position furhter
        const currentScheme = navbar.classList.contains('bg-transparent')
            ? 'light'
            : 'dark';

        if ((isLightScheme && currentScheme !== 'light') ||
            (!isLightScheme && currentScheme !== 'dark')) {
            // The color scheme has changed, update the style

            if (isLightScheme) {

                // Scroll position is within the hero section

                navbar.classList.remove(
                    'bg-white',
                    'text-black',
                );
                navbar.classList.add('bg-transparent', 'text-white');

                // Remove the 'active' class from the mobile menu button to change
                // the color of the hamburger icon (including pseudo elements)
                mobileMenuButton.classList.remove('active');
                mobileMenuBtnContainer.classList.remove(
                    'bg-white',
                    'border-[1px]',
                    'border-black',
                );
                mobileMenuBtnContainer.classList.add(
                    'bg-grey-100/10',
                    'border-[1px]',
                    'border-grey-100/30',
                );
                // Update the logo source to logotyppadding.svg
                logoImage.src = themeFileURI + '/static/images/logo_light.svg';

            } else {

                // Scroll position is outside the hero section

                // Change the navbar background color to white
                navbar.classList.remove('bg-transparent', 'text-white');
                navbar.classList.add(
                    'bg-white',
                    'text-black',
                );

                // Add the 'active' class to the mobile menu button to change
                // the color of the hamburger icon (including pseudo elements)
                mobileMenuButton.classList.add('active');
                mobileMenuBtnContainer.classList.remove(
                    'bg-grey-100/10',
                    'border-[1px]',
                    'border-grey-100/30',
                );
                mobileMenuBtnContainer.classList.add(
                    'bg-white',
                    'border-[1px]',
                    'border-black',
                );
                // Update the logo source to logo_large.png
                logoImage.src = themeFileURI + '/static/images/logo_dark.svg';
            }
        }
    }

    // Call the function to check the navbar style on page load
    updateNavbarStyle();

    // Add a scroll event listener to call the function when scrolling
    window.addEventListener('scroll', updateNavbarStyle);

});
//# sourceMappingURL=main.js.map
